import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import SidebarTree from './SidebarTree';
import SidebarItem from './SidebarItem';
import socket from '../../helpers/socket';
import {isTeamMember, isLocationCustomer, isCustomerUser} from '../../helpers/utils';
import SidebarMultiTree from './SidebarMultiTree';

class Sidebar extends Component {

	_switchRoleAction = (roleId) => (e) => {
		e.preventDefault();
		const {switchRoleAction, session} = this.props;

		if(session) {
			socket().emit('role.leave', session.active_role_id);
			socket().emit('role.join', roleId);
		}
		switchRoleAction(roleId);
	};

	render() {
		const {translate, session} = this.props;
		const permissionNames = session.permission_names;
		const roles = session.user_roles;

		// const treeMenuItems = [
		// 	{
		// 		title: 'Tree One',
		// 		url: ''
		// 	},
		// 	{
		// 		title: 'Tree Two',
		// 		url: ''
		// 	}
		// ];
		// const multiTreeMenuItems = [
		// 	{
		// 		title: 'Tree One',
		// 		url: ''
		// 	},
		// 	{
		// 		title: 'Tree Two',
		// 		sideBarItem: [
		// 			{
		// 				title: 'Tree One',
		// 				url: ''
		// 			},
		// 			{
		// 				title: 'Tree Two',
		// 				url: ''
		// 			}
		// 		]
		// 	}
		// ];

		let activeRole = null, useAsRoles = [];
		if(roles && roles.length) {
			activeRole = roles.find(role => role.id === session.active_role_id);
			useAsRoles = roles.filter(role => role.id !== session.active_role_id);
		}

		let viewRole = false;
		let viewRegion = false, viewBusinessUnit = false, viewStation = false;
		let viewUser = false;

		let viewWorkOrder = false, createWorkOrder = false, approveWorkOrder = false, searchWorkOrder = false;
		let viewInspection = false, createInspection = false, approveInspection = false, searchInspection = false, workInspection = false;

		let createPaidHour = false, createBillHour = false, createWorkBillHour = false, editWorkBillHour = false;
		let viewReport = false;
		let viewCustomer = false;
		let viewAuditQuestion = false;
		let viewAudit = false, createAudit = false;
		let viewWorkInstruction = false, createWorkInstruction = false;
		let viewShiftNote = false;
		let viewAlertLibrary = false;
		let viewPartLibrary = false;
		let viewBin = false, doBinPartVerification = false, doBinPartLabeling = false;
		let sendSms = false;
		let viewSms = false;
		let viewPlex = false;
		let viewInvoice = false;
		let viewVertex = false;
		let viewVin = false, scanVin = false;
		let viewQuestion = false, createQuestion = false;
		let viewTimeClock = false, createTimeClock = false, approveTimeClock = false;

		if(permissionNames && permissionNames.length) {
			permissionNames.forEach(permission => {
				switch (permission) {
					case 'view_role': viewRole = true; break;
					case 'view_region': viewRegion = true; break;
					case 'view_business_unit': viewBusinessUnit = true; break;
					case 'view_station': viewStation = true; break;

					case 'view_user': viewUser = true; break;

					case 'view_work_order': viewWorkOrder = true; break;
					case 'create_work_order': createWorkOrder = true; break;
					case 'approve_work_order': approveWorkOrder = true; break;
					case 'search_work_order': searchWorkOrder = true; break;

					case 'view_inspection': viewInspection = true; break;
					case 'create_inspection': createInspection = true; break;
					case 'approve_inspection': approveInspection = true; break;
					case 'search_inspection': searchInspection = true; break;
					case 'work_inspection': workInspection = true; break;

					case 'create_paid_hour': createPaidHour = true; break;
					case 'create_bill_hour': createBillHour = true; break;
					case 'create_work_bill_hour': createWorkBillHour = true; break;
					case 'edit_work_bill_hour': editWorkBillHour = true; break;
					case 'view_report': viewReport = true; break;
					case 'view_customer': viewCustomer = true; break;

					case 'view_audit_question': viewAuditQuestion = true; break;
					case 'view_audit': viewAudit = true; break;
					case 'create_audit': createAudit = true; break;

					case 'view_work_instruction': viewWorkInstruction = true; break;
					case 'create_work_instruction': createWorkInstruction = true; break;

					case 'view_shift_note': viewShiftNote = true; break;
					case 'view_alert_library': viewAlertLibrary = true; break;

					case 'view_part_library': viewPartLibrary = true; break;
					case 'view_bin': viewBin = true; break;
					case 'do_bin_part_verification': doBinPartVerification = true; break;
					case 'do_bin_part_labeling': doBinPartLabeling = true; break;

					case 'send_sms': sendSms = true; break;
					case 'view_sms': viewSms = true; break;
					case 'view_plex': viewPlex = true; break;
					case 'view_invoice': viewInvoice = true; break;

					case 'view_vertex': viewVertex = true; break;

					case 'view_vin': viewVin = true; break;
					case 'scan_vin': scanVin = true; break;

					case 'view_question': viewQuestion = true; break;
					case 'create_question': createQuestion = true; break;

					case 'view_time_clock': viewTimeClock = true; break;
					case 'create_time_clock': createTimeClock = true; break;
					case 'approve_time_clock': approveTimeClock = true; break;

					default: break;
				}
			});
		}

		const dashboardMenuItems = [];
		dashboardMenuItems.push({title: translate('navigation.dashboard1'), url: '/dashboard'});
		if(!isTeamMember(session)) {
			dashboardMenuItems.push({title: translate('navigation.dashboard2'), url: '/dashboard/2'});
		}
		if(isLocationCustomer(session)) {
			dashboardMenuItems.push({title: translate('navigation.dashboard3'), url: '/dashboard/3'});
		}
		if(!isCustomerUser(session)) {
			dashboardMenuItems.push({title: translate('navigation.dashboard4'), url: '/dashboard/4'});
			dashboardMenuItems.push({title: translate('navigation.dashboard5'), url: '/dashboard/5'});
			dashboardMenuItems.push({title: translate('navigation.dashboard6'), url: '/dashboard/6'});
			dashboardMenuItems.push({title: translate('navigation.dashboard8'), url: '/dashboard/8'});
		}
		dashboardMenuItems.push({title: translate('navigation.dashboard7'), url: '/dashboard/7'});

		const organizationMenuItems = [];
		if(viewRegion) {
			organizationMenuItems.push({title: translate('navigation.view_regions'), url: '/organizations/regions'});
		}
		if(viewBusinessUnit) {
			organizationMenuItems.push({title: translate('navigation.view_business_units'), url: '/organizations/business-units'});
		}
		if(viewStation) {
			organizationMenuItems.push({title: translate('navigation.view_stations'), url: '/organizations/stations'});
		}

		const invoiceMenuItems = [];
		if(viewInvoice) {
			invoiceMenuItems.push({title: translate('navigation.view_invoices'), url: '/invoices'});
			invoiceMenuItems.push({title: translate('navigation.invoice_search'), url: '/invoices/search'});
		}

		const workOrderMenuItems = [];
		if(createWorkOrder) {
			workOrderMenuItems.push({
				title: translate('navigation.create_work_order'),
				url: '#',
				sideBarItem: [
					{title: "Standard WO", url: '/work-orders/create/standard/step-one'},
					{title: "Operations WO", url: '/work-orders/create/operations/step-one'},
					{title: "Sale WO", url: '/work-orders/create/billing/step-one'},
					{title: "Inspection Campaign", url: '/work-orders/create/inspection/step-one'},
					{title: "Repair Campaign", url: '/work-orders/create/repair/step-one'},
				]
			});
		}
		if(approveWorkOrder) {
			workOrderMenuItems.push({title: translate('navigation.approve_work_order'), url: '/work-orders/approve'});
		}
		if(viewWorkOrder) {
			workOrderMenuItems.push({title: translate('navigation.view_work_order_open'), url: '/work-orders/view/open'});
			workOrderMenuItems.push({title: translate('navigation.view_work_order_closed'), url: '/work-orders/view/closed'});
		}
		if(searchWorkOrder) {
			workOrderMenuItems.push({title: translate('navigation.search_work_order'), url: '/work-orders/search'});
		}

		const inspectionMenuItems = [];
		if(createInspection) {
			inspectionMenuItems.push({title: translate('navigation.create_inspection'), url: '/inspections/create'});
		}
		if(approveInspection) {
			inspectionMenuItems.push({title: translate('navigation.approve_inspection'), url: '/inspections/approve'});
		}
		if(viewInspection) {
			inspectionMenuItems.push({title: translate('navigation.view_inspection'), url: '/inspections'});
		}
		if(searchInspection) {
			inspectionMenuItems.push({title: translate('navigation.search_inspection'), url: '/inspections/search'});
		}
		if(workInspection) {
			inspectionMenuItems.push({title: translate('navigation.work_inspection'), url: '/inspections/work'});
		}
		if(createWorkBillHour) {
			inspectionMenuItems.push({title: translate('navigation.create_work_bill_hours'), url: '/work-bill-hours/create'});
		}
		if(editWorkBillHour) {
			inspectionMenuItems.push({title: translate('navigation.edit_work_bill_hours'), url: '/work-bill-hours/update'});
		}

		const vinsMenuItems = [];
		if (viewVin) {
			vinsMenuItems.push({title: translate('navigation.view_vins'), url: '/vins'});
		}
		if (scanVin) {
			vinsMenuItems.push({title: translate('navigation.scan_vins'), url: '/vins/scan'});
		}
		if (viewQuestion) {
			vinsMenuItems.push({title: translate('navigation.create_question'), url: '/questions/create'})
		}
		if (createQuestion) {
			vinsMenuItems.push({title: translate('navigation.view_question'), url: '/questions'})
		}
		if(approveWorkOrder) {
			vinsMenuItems.push({title: translate('navigation.finalize_work_order'), url: '/work-orders/finalize'});
		}
		if (scanVin) {
			vinsMenuItems.push({title: translate('navigation.view_reports_answer_question'), url: '/reports/answer-question'});
		}

		const auditMenuItems = [];
		if(createAudit) {
			auditMenuItems.push({title: translate('navigation.create_audit'), url: '/audits/create'});
		}
		if(viewAudit) {
			auditMenuItems.push({title: translate('navigation.view_audit'), url: '/audits'})
		}
		if(viewAuditQuestion) {
			auditMenuItems.push({title: translate('navigation.view_audit_question'), url: '/audits/questions'})
		}

		const workInstructionMenuItems = [];
		if(createWorkInstruction) {
			workInstructionMenuItems.push({title: translate('navigation.create_work_instruction'), url: '/work-instructions/create'})
		}
		if(viewWorkInstruction) {
			workInstructionMenuItems.push({title: translate('navigation.view_work_instruction'), url: '/work-instructions'})
		}

		const partVerificationMenuItems = [];
		if(viewBin) {
			partVerificationMenuItems.push({title: translate('navigation.bins_verification'), url: '/bins/verification'})
		}
		if(doBinPartVerification) {
			partVerificationMenuItems.push({title: translate('navigation.binPartVerification'), url: '/bin-part-verifications/do'})
		}
		if(viewPartLibrary) {
			partVerificationMenuItems.push({title: translate('navigation.part_libraries'), url: '/part-libraries'})
		}
		if(doBinPartLabeling) {
			partVerificationMenuItems.push({title: translate('navigation.bins_labeling'), url: '/bins/labeling'})
		}

		const shiftNoteMenuItems = [];
		if(viewShiftNote) {
			shiftNoteMenuItems.push({title: translate('navigation.view_shift_note'), url: '/shift-notes'})
		}

		const reportMenuItems = [];
		if(viewReport) {
			reportMenuItems.push({title: translate('navigation.view_reports_hours_worked'), url: '/reports/hours-worked'});
			reportMenuItems.push({title: translate('navigation.view_reports_hours_worked_vs_hours_paid'), url: '/reports/hours-worked-vs-hours-paid'});
			reportMenuItems.push({title: translate('navigation.view_reports_hours_worked_vs_hours_billed'), url: '/reports/hours-worked-vs-hours-billed'});
			reportMenuItems.push({title: translate('navigation.view_reports_total_inspected_vs_total_rejected'), url: '/reports/total-inspected-vs-total-rejected'});
			reportMenuItems.push({title: translate('navigation.view_reports_time_clocked_hours'), url: '/reports/time-clocked-hours'});
			reportMenuItems.push({title: translate('navigation.view_reports_billable_items'), url: '/reports/billable-items'});
			reportMenuItems.push({title: translate('navigation.view_reports_billable_items_vs_invoice'), url: '/reports/billable-items-vs-invoice'});
			reportMenuItems.push({title: translate('navigation.view_reports_billable_items_vs_purchase_orders'), url: '/reports/billable-items-vs-purchase-orders'});
			reportMenuItems.push({title: translate('navigation.view_reports_invoice_items'), url: '/reports/invoice-items'});
			reportMenuItems.push({title: translate('navigation.view_reports_invoice_aging'), url: '/reports/invoice-aging'});
			reportMenuItems.push({title: translate('navigation.view_reports_invoice_sent'), url: '/reports/invoice-sent'});
			reportMenuItems.push({title: translate('navigation.view_reports_work_orders'), url: '/reports/work-orders'});
			reportMenuItems.push({title: translate('navigation.view_reports_daily_production'), url: '/reports/daily-production'});
			// reportMenuItems.push({title: translate('navigation.view_reports_daily_campaign_summary'), url: '/reports/daily-campaign-summary'});
			// reportMenuItems.push({title: translate('navigation.view_reports_hold_vin_list'), url: '/reports/hold-vin-list'});
			reportMenuItems.push({title: translate('navigation.view_reports_answer_question'), url: '/reports/answer-question'});
		}

		const smsMenuItems = [];
		if(sendSms) {
			smsMenuItems.push({title: translate('navigation.send_sms'), url: '/sms/send'});
		}
		if(viewSms) {
			smsMenuItems.push({title: translate('navigation.view_sms'), url: '/sms'});
		}

		const timeClockMenuItems = [];
		if(createTimeClock) {
			timeClockMenuItems.push({title: translate('navigation.create_time_clock'), url: '/time-clocks/create'});
		}
		if(approveTimeClock) {
			timeClockMenuItems.push({title: translate('navigation.approve_time_clock'), url: '/time-clocks/approve'});
		}
		if(viewTimeClock) {
			timeClockMenuItems.push({title: translate('navigation.view_time_clock'), url: '/time-clocks'});
		}

		return (
			<Fragment>
				<aside className="main-sidebar">
					<section className="sidebar">
						<ul className="sidebar-menu" data-widget="tree">
							<li className="header">
								<div className="media">
									<div className="media-left">
										<i className="role-icon fa fa-user-circle fa-4x"/>
									</div>
									<div className="media-body media-middle">
										<h5 className="media-heading role-type">{ activeRole && activeRole.name }</h5>
										{ session.user && session.user.email }
									</div>
								</div>
							</li>

							<SidebarTree title={translate('navigation.dashboard')} url="#" iconClass="fa fa-desktop" sideBarItem={dashboardMenuItems}/>

							{
								(invoiceMenuItems.length > 0) &&
								<SidebarMultiTree title={translate('navigation.invoices')} url="#" iconClass="fa fa-usd" sideBarTree={invoiceMenuItems}/>
							}

							{
								(workOrderMenuItems.length > 0) &&
								<SidebarMultiTree title={translate('navigation.work_orders')} url="#" iconClass="fa fa-cubes" sideBarTree={workOrderMenuItems}/>
							}

							{
								(inspectionMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.inspections')} url="#" iconClass="fa fa-calendar-check-o" sideBarItem={inspectionMenuItems}/>
							}

							{
								(vinsMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.vins')} url="#" iconClass="fa fa-car" sideBarItem={vinsMenuItems}/>
							}

							{
								(createPaidHour) &&
								<SidebarItem title={translate('navigation.create_paid_hours')} url="/paid-hours/create" iconClass="fa fa-clock-o"/>
							}

							{
								(createBillHour) &&
								<SidebarItem title={translate('navigation.create_bill_hours')} url="/bill-hours/create" iconClass="fa fa-pencil"/>
							}

							{
								(auditMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.audits')} url="#" iconClass="fa fa-edit" sideBarItem={auditMenuItems}/>
							}

							{
								(workInstructionMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.work_instructions')} url="#" iconClass="fa fa-book" sideBarItem={workInstructionMenuItems}/>
							}

							{
								(timeClockMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.time_clocks')} url="#" iconClass="fa fa-hourglass-start" sideBarItem={timeClockMenuItems}/>
							}

							{
								(shiftNoteMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.shift_notes')} url="#" iconClass="fa fa-sticky-note-o" sideBarItem={shiftNoteMenuItems}/>
							}

							{(partVerificationMenuItems.length > 0) && (
								<SidebarTree title={translate('navigation.part_verifications')} url="#" iconClass="fa fa-search" sideBarItem={partVerificationMenuItems}/>
							)}

							{
								(smsMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.sms')} url="#" iconClass="fa fa-send" sideBarItem={smsMenuItems}/>
							}

							{
								(reportMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.reports')} url="#" iconClass="fa fa-bar-chart" sideBarItem={reportMenuItems}/>
							}

							{
								(viewPlex) &&
								<SidebarItem title={translate('navigation.plex')} url="/plex" iconClass="fa fa-cogs"/>
							}

							{
								(viewVertex) &&
								<SidebarItem title={translate('navigation.vertex')} url="/vertex" iconClass="fa fa-cogs"/>
							}

							{
								(viewRole) &&
								<SidebarItem title={translate('navigation.roles')} url="/roles" iconClass="fa fa-cogs"/>
							}

							{
								(organizationMenuItems.length > 0) &&
								<SidebarTree title={translate('navigation.organizations')} url="#" iconClass="fa fa-university" sideBarItem={organizationMenuItems}/>
							}

							{
								(viewUser) &&
								<SidebarItem title={translate('navigation.users')} url="/users" iconClass="fa fa-users"/>
							}

							<SidebarItem title={translate('navigation.andons')} url="/andons" iconClass="fa fa-warning"/>

							{
								(viewAlertLibrary) &&
								<SidebarItem title={translate('navigation.alert_libraries')} url="/alert-libraries" iconClass="fa fa-cubes"/>
							}

							{
								(viewCustomer) &&
								<SidebarItem title={translate('navigation.view_customers')} url="/customers" iconClass="fa fa-user"/>
							}

							{
								useAsRoles.map(role => {
									return (
										<li key={`sidebar_use_as_${role.id}`}>
											<Link to={`/auth/switch/${role.id}`} onClick={this._switchRoleAction(role.id)}>
												<i className="fa fa-circle-o text-yellow"/>
												<span>{translate("navigation.use_as", {role_title: role.name})}</span>
											</Link>
										</li>
									)
								})
							}
						</ul>
					</section>
				</aside>
				<Helmet script={[{
					'type': 'text/javascript',
					'innerHTML': '$(".sidebar-menu").tree();'
				}]}/>
			</Fragment>
		)
	}
}

Sidebar.propTypes = {
	translate: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	switchRoleAction: PropTypes.func.isRequired
};

export default Sidebar
